<form *ngIf="stage === 'phone'" [formGroup]="phoneForm">
    <ph-field>
        <ph-label>Enter your mobile number</ph-label>
        <ph-input formControlName="phone"
                  ngDefaultControl
                  type="tel"
                  inputmode="numeric"
                  [mask]="phoneNumberValidationMask"
                  [placeholder]="phoneNumberValidationMask"
                  aria-label="Mobile number"
                  (keyup.enter)="next()"></ph-input>
        <lf-control-messages hint [control]="phoneForm.controls.phone" [prefix]="'Mobile number'"></lf-control-messages>
        <ph-hint>We'll text a 6-digit code to this number each time you sign in.</ph-hint>
    </ph-field>
</form>

<ph-stack *ngIf="stage === 'code'">
    <div>Enter the 6-digit code we texted to <strong>{{ phoneForm.controls.phone.value | legfiPhone }}</strong></div>

    <ph-stack gap="snug" align="center">
        <ph-digit-input digits="6"
                        aria-label="Verification code"
                        auto-focus
                        [value]="code"
                        [disabled]="isSaving || isSuccess"
                        [hasError]="hasError"
                        (ph-change)="onCodeChange($event.detail)"
                        (ph-complete)="verify($event.detail)"></ph-digit-input>

        <ph-toolbar gap="tight" nowrap>
            <ph-hint>Didn't get a code?</ph-hint>
            <ph-link-button variant="primary"
                            size="small"
                            [disabled]="isResending || isSaving || isSuccess"
                            (click)="resendCode()">{{ isResending ? 'Sending…' : 'Resend' }}</ph-link-button>
        </ph-toolbar>
    </ph-stack>
</ph-stack>

<app-recovery-codes-panel *ngIf="stage === 'codes'"
                          [codes]="recoveryCodes"
                          (acknowledgedChange)="codesAcknowledged = $event"></app-recovery-codes-panel>

<ng-template #footer>
    <ph-actions slot="footer" align="between" *ngIf="stage === 'phone'">
        <ph-button variant="secondary" mode="filled" [disabled]="isSending" (click)="onBack()">{{ dismissLabel }}</ph-button>
        <ph-button [disabled]="phoneForm.invalid || isSending" (click)="next()">{{ isSending ? 'Sending…' : 'Send code' }}</ph-button>
    </ph-actions>

    <ph-actions slot="footer" align="between" *ngIf="stage === 'code'">
        <ph-button variant="secondary" mode="filled" [disabled]="isSaving || isSuccess" (click)="onBack()">Back</ph-button>
        <ph-button [disabled]="code.length < 6 || isSaving || isSuccess" (click)="verify(code)">{{ verifyLabel }}</ph-button>
    </ph-actions>

    <ph-actions slot="footer" *ngIf="stage === 'codes'">
        <ph-button [disabled]="!codesAcknowledged" (click)="onCodesAcknowledged()">Done</ph-button>
    </ph-actions>
</ng-template>
